import React from "react";
import { BiDonateHeart } from "react-icons/bi";

const CinqueXmille = () => {
  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl bg-gradient-to-r from-white to-amber-50">
      <BiDonateHeart className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <p className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        5X1000
      </p>
      <div className="flex flex-col items-center w-2/3 mt-5 z-10">
        <p className="text-center">
          Il 5x1000 è un sostegno alle associazioni e a costo zero per il
          cittadino, che può scegliere a chi destinare una quota del proprio
          IRPEF.
        </p>
        <p className="text-center">
          Donando il tuo 5 per mille a Milarte contribuisci anche tu a
          promuovere la cultura musicale in Italia.
        </p>
        <p className="text-center">
          Inserisci questo codice fiscale nella tua dichiarazione dei redditi:
        </p>
        <p className="text-blue-600 text-6xl ">97952360150</p>
        <p className="text-center">
          MilArte è un'Associazione di Promozione Sociale dedicata alla musica,
          fondata nel 2023 con l'obiettivo di diffondere la passione per la
          musica e creare un impatto positivo nella comunità attraverso
          iniziative musicali significative. La visione di Giuseppe Dinardo ha
          guidato la fondazione dell'associazione consolidando la sua presenza
          nel panorama musicale locale grazie alla dedizione dei membri e al
          sostegno della comunità.
        </p>
        <p className="text-center mt-5">
          Gli obiettivi principali di MilArte includono la proposta di concerti,
          eventi e manifestazioni varie, con la convinzione che la musica possa
          trasformare e arricchire la vita di tutti. L'associazione si impegna
          instancabilmente per rendere la musica accessibile a un pubblico
          ampio. Le attività di MilArte comprendono programmi e iniziative volte
          a promuovere la cultura musicale e a coinvolgere la comunità in
          esperienze musicali significative.
        </p>
        <p className="text-center mt-5 mb-5">
          In preparazione abbiamo anche visite e concerti nelle scuole, con
          l'ambizione di suscitare la meraviglia di fronte alla musica fatta con
          mani umane, e condividere dimensioni di senso e cultura con i giovani.
          Vorremmo essere Orchestra "Nuova" anche nell'accezione particolare di
          diffondere cultura e nutrire interiormente i nostri uditori.
        </p>
      </div>
    </div>
  );
};

export default CinqueXmille;
